module.exports = __webpack_public_path__ + "static/media/ico_escudo_new.d1dd44b8.svg";